import { ref } from 'vue'
import { zmgPublicCacheClient } from '@api-client/zmg_cache'

export const hostnameByStoreId = ref<Record<string, string | null>>({})

export const loadStoreHostname = async (storeId: string) => {
    if (storeId in hostnameByStoreId.value) return
    try {
        const { data } = await (
            await zmgPublicCacheClient.store.website_settings[':id']['data.json'].$get({
                param: { id: storeId },
            })
        ).json()
        if (!data?.connectWebsiteId) {
            hostnameByStoreId.value = {
                ...hostnameByStoreId.value,
                [storeId]: null,
            }
            return
        }
        const { data: defaultHostname } = await (
            await zmgPublicCacheClient.website.find_default_hostname_by_website_id[':id']['data.json'].$get({
                param: { id: data.connectWebsiteId },
            })
        ).json()
        hostnameByStoreId.value = {
            ...hostnameByStoreId.value,
            [storeId]: defaultHostname?.defaultHostname ?? null,
        }
    } catch {
        // keep last known value
    }
}

export const getStoreHostname = (storeId: string) => {
    return hostnameByStoreId.value[storeId] ?? null
}
